import { default as React, useEffect, useContext, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import List from "./list";
import httpService from "core/infrastructure/http";
import { ValidationDaDto, GetValidationDaResponse, GetValidationDaQuery } from "core/backend/data";
import SheetDataPart from "components/sheetDataPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import { keys } from "ts-transformer-keys";
import { PageList } from "core/pages/pageList";

interface OwnState {
    applicationState: ApplicationState;
}
export const senderId = "validationDa";

export const page_config: PageList =
{
    apiUrl: "validationDa",
    webUrl: "CCR_validationDa",
    menu: "ibwt_common:menuValidationDa",
    title: "ibwt_common:titleValidationDa",
    apiType: "data",
    response: JSON.stringify(keys<GetValidationDaResponse>()),
    dto: JSON.stringify(keys<ValidationDaDto>()),
    parameters: JSON.stringify(keys<GetValidationDaQuery>()),
    dateSteps: "D",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};
type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {

    const initialResponse: GetValidationDaResponse = { data: [], messages: [], rejected: false };
    const [response, setResponse] = useState(initialResponse);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [search, setSearch] = useState("");
    const [searchText, setSearchText] = useState("");
    const keysInDto = keys<ValidationDaDto>();

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, false, false, keysInDto);
            setLoading(true);
            setResponse(initialResponse);
            const response = await httpService.apiPost<GetValidationDaResponse>({
                applicationState: applicationState,
                route: applicationState.apiService + "/" + page_config.apiType + "/" + page_config.apiUrl,
                query: {
                    FromUtc: applicationState.getRootUtcTime().toISOString(),
                    ToUtc: applicationState.getUntilFor1Day().toISOString(),
                    Filter: search, Skip: 0, Take: 1000
                },
                senderId: senderId
            })();

            if (response.ok) {
                setResponse(response.data);
                setError("");
                setLoading(false);
            } else if ((response.cancel || false) === false) {
                setError(response.error || t("common:UnknownError"));
                setLoading(false);
            }
        })();
    }, [applicationState.selectedDate, search]);

    return (
        <>
            <SheetHeader showDownload={true} applicationState={applicationState} title={t(page_config.title)} pageConfig={page_config} />
            <div className="subHeader">
                <div style={{ display: "inline-block" }}>
                    <div className="inputlabel">{t("core_Search")}</div>
                    <input className="inputTable" type="text" value={searchText}
                        onChange={(e) => setSearchText(e.currentTarget.value)}
                        onBlur={(e) => { setSearch(e.currentTarget.value); }}
                        onKeyDown={(e) => { if (e.keyCode === 13) e.currentTarget.blur(); }} />
                </div>
            </div>
            <SheetDataPart isLoading={isLoading} data={response.data} error={error}>
                <List data={response.data.slice(0, applicationState.maxRows)} hubs={applicationState.selectedHubs.filter(h => keysInDto.some((key) => key === "ptdfRefs_" + h.id.toUpperCase()))} />
            </SheetDataPart>
        </>
    );
};

export default withTranslation()(Page);
